<template>
<div>
    <Box  @close="close({})">
        <template v-slot:top>Registrar Pedido</template>
        <template v-slot:center>
            <div class="nj-cols">
                <div class="nj-card nj-cols">
                    <div class="nj-subtitle-1">Cliente</div>
                    <div class="nj-cols form" style="grid-template-columns: 1fr auto;">
                        <!-- <Search id="search-cliente" label="Cliente" itemKey="cli_id" itemLabel="cli_nombre" :items="clientes" @search="buscarCliente($event)" @select="seleccionarCliente($event)">
                            <template #default="data">
                                <div style="display: grid; grid-template-columns: 1fr auto;">
                                    <span>{{ data.item.cli_documento_identidad }} {{ data.item.cli_nombre }}</span>
                                </div>
                            </template>
                        </Search> -->
                        <button class="nj-button nj-align-self-end c-green" @click="popup({ componente: 'registrar', abrir: true })">Nuevo</button>
                    </div>
                    <div class="nj-subtitle-1">Contacto Receptor</div>
                    <div class="nj-cols form c4">
                        <InputForm text="Nombres y apellidos">
                            <input type="text" class="nj-text" v-model="orden_venta.ovt_nombre_contacto">
                        </InputForm>
                        <InputForm text="Documento identidad">
                            <input type="text" class="nj-text" v-model="orden_venta.ovt_documento_identidad_contacto">
                        </InputForm>
                        <InputForm text="Telefono / Celular">
                            <input type="text" class="nj-text" v-model="orden_venta.ovt_telefono_contacto">
                        </InputForm>
                        <InputForm text="Correo">
                            <input type="text" class="nj-text" v-model="orden_venta.ovt_correo_contacto">
                        </InputForm>
                    </div>
                </div>
                <div class="nj-card nj-cols">
                    <div class="nj-subtitle-1">Pedido</div>
                    <div class="nj-cols form">
                        <div class="nj-cols form c5">
                            <Search id="search-vendedor" label="Vendedor" itemLabel="ven_nombre" itemKey="ven_id" :items="vendedores" @search="buscarVendedor($event)"
                                @select="seleccionarVendedor($event)">
                                <template #default="data">
                                    <span>{{ data.item.ven_documento_identidad }} {{ data.item.ven_nombre }}</span>
                                </template>
                            </Search>
                            <InputForm text="Fecha y hora solicitada">
                                <div class="nj-flx">
                                    <Fecha :data="fecha_hora" />
                                    <Hora :data="fecha_hora" />
                                </div>
                            </InputForm>
                            <InputForm text="Tipo de comprobante">
                                <select class="nj-select" v-model="orden_venta.tid_id">
                                    <option v-for="item in tipos_documento" :key="item.tid_id" :value="item.tid_id">{{ item.tid_descripcion }}</option>
                                </select>
                            </InputForm>
                            <InputForm text="Condición de pago">
                                <select class="nj-select" v-model="orden_venta.coc_id">
                                    <option v-for="item in condiciones_comerciales" :key="item.coc_id" :value="item.coc_id">{{ item.coc_descripcion }}</option>
                                </select>
                            </InputForm>
                            <InputForm text="Numero Guia">
                                <input type="text" class="nj-text" v-model="orden_venta.ovt_guia">
                            </InputForm>
                        </div>
                        <InputForm text="Observaciones">
                            <textarea class="nj-text" cols="30" rows="4" v-model="orden_venta.ovt_observaciones"></textarea>
                        </InputForm>
                    </div>
                    <div class="nj-subtitle-1">Dirección de envio</div>
                    <div class="nj-cols c3 form">
                        <div>
                            <div class="nj-label">Dirección</div>
                            <input type="text" class="nj-text" v-model="orden_venta.ovt_direccion_envio">
                        </div>
                        <div>
                            <div class="nj-label">Referencia</div>
                            <input type="text" class="nj-text" v-model="orden_venta.ovt_referencia_envio">
                        </div>
                        <InputForm text="Distrito">
                            <select class="nj-select" v-model="orden_venta.ubi_id">
                                <option v-for="item in distritos" :key="item.ubi_id" :value="item.ubi_id">{{ item.ubi_nombre }}</option>
                            </select>
                        </InputForm>
                    </div>
                </div>
                <div class="nj-card">
                    <div class="nj-subtitle-1">Productos</div>
                    <div class="nj-cols form" style="grid-template-columns: 1fr auto;">
                        <Search id="search-producto" label="Producto" itemKey="pvt_id" :items="productos" @search="buscarProducto($event)" itemLabel="pvt_nombre" @select="agregarProducto($event)">
                            <template #default="data">
                                <span>{{ data.item.pvt_nombre }}</span>
                            </template>
                        </Search>
                    </div>
                    <br>
                    <div class="nj-scroll-x">
                        <div class="data-grid">
                            <div class="data-grid-title cols">
                                <div>Producto</div>
                                <div>Min. - Max.</div>
                                <div>Precio</div>
                                <div>Cantidad</div>
                                <div>Importe</div>
                                <div>Opciones</div>
                            </div>
                            <div class="data-grid-body cols" v-for="item in orden_venta.lista_orden_venta_detalle" :key="item.sequence">
                                <div>{{ item.ovd_producto }}</div>
                                <div class="nj-text-center">S/ {{ item.pvt_precio_minimo }} - S/ {{ item.pvt_precio }}</div>
                                <div>
                                    <input type="text" class="nj-text nj-text-right" v-model="item.ovd_precio" @keyup="calcular()">
                                </div>
                                <div>
                                    <input type="text" class="nj-text nj-text-right" v-model="item.ovd_cantidad" @keyup="calcular()">
                                </div>
                                <div>
                                    <input type="text" class="nj-text nj-text-right" v-model="item.ovd_subtotal" disabled>
                                </div>
                                <div class="nj-flx center">
                                    <button class="nj-button icon c-red" @click="removerProducto(item.sequence)" title="Remover"><i class="mdi-delete"></i></button>
                                </div>
                            </div>
                            <template v-if="orden_venta.lista_orden_venta_detalle.length != 0">
                                <div class="data-grid-footer cols">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div class="nj-text-right nj-bold">Subtotal</div>
                                    <div>
                                        <input type="text" class="nj-text nj-text-right" v-model="orden_venta.ovt_subtotal" disabled>
                                    </div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="data-grid-footer cols">
                                    <div></div>
                                    <div></div>
                                    <div class="nj-text-right nj-bold">IGV</div>
                                    <div>
                                        <input type="text" class="nj-text nj-text-right" v-model="orden_venta.ovt_igv_tasa" @keyup="calcular()" disabled>
                                    </div>
                                    <div>
                                        <input type="text" class="nj-text nj-text-right" v-model="orden_venta.ovt_igv" disabled>
                                    </div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="data-grid-footer cols">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div class="nj-text-right nj-bold">Total</div>
                                    <div>
                                        <input type="text" class="nj-text nj-text-right" v-model="orden_venta.ovt_total" disabled>
                                    </div>
                                    <div></div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:bottom>
            <button class="nj-button c-green" @click="registrar()"><i class=" mdi-content-save"></i>Registrar</button>
        </template>
    </Box>
    <RegistrarCliente v-if="activarRegistrar" @close="popup($event)" @closeRetornarData="popup($event)" :lista_tipo_documento_identidad="tipos_documento_identidad" :returnData="true" />
</div>
</template>

<script>
import { mapActions } from "vuex"
import RegistrarCliente from "../../modules/cliente/RegistrarCliente.vue"
import { AppService, ClienteService, OrdenVentaService, ResponseStatus, VendedorService } from "../../services"
import ProductoVentaService from "../../services/ProductoVentaService"
import { UsuarioService } from "../../services"
import { Arrays, DateTime, Numbers, Toast, Validator } from "../../util/"
import { Fecha, Hora, InputForm, Box, Search, Button } from "../components"

export default {
    components: {
        Fecha,
        Hora,
        Box,
        InputForm,
        RegistrarCliente,
        Search,
    },
    name: "RegistrarOrdenVenta",
    data() {
        return {
            orden_venta: {
                cli_id: null,
                cde_id: null,
                tid_id: null,
                mon_id: null,
                coc_id: null,
                ovt_nombre_contacto: null,
                ovt_telefono_contacto: null,
                ovt_correo_contacto: null,
                ovt_documento_identidad_contacto: null,
                ovt_observaciones: null,
                ovt_fecha_entrega: null,
                ovt_subtotal: 0,
                ovt_igv_tasa: 0.18,
                ovt_igv: 0,
                ovt_total: 0,
                ovt_registrador: UsuarioService.getUsuario().usu_id,
                ven_id: null,
                lista_orden_venta_detalle: [],
            },
            sequence: 1,
            clientes: [],
            vendedores: [],
            productos: [],
            distritos: [],
            monedas: [],
            condiciones_comerciales: [],
            tipos_documento: [],
            direcciones_envio: [],
            tipos_documento_identidad: [],
            fecha_hora: {
                day: null,
                month: null,
                year: null,
                hour: null,
                min: null,
            },
            activarRegistrar: false,
            cli_id: null,
        }
    },
    methods: {
        ...mapActions("AppStore", [
            "_loadingOn",
            "_loadingOff",
        ]),
        buscarCliente(value) {
            this.direcciones_envio = []
            this.clientes = []
            if (value) {
                ClienteService.buscar({
                    cliente: {
                        cli_search: value
                    }
                }).then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.clientes = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                }, error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
            }
            else {
                Toast.error("Debe ingresar alguna referencia del empleado")
                this.clientes = []
            }
        },
        buscarVendedor(value) {
            this.direcciones_envio = []
            this.vendedores = []
            if (value) {
                VendedorService.buscar({
                    vendedor: {
                        ven_nombre: value
                    }
                }).then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.vendedores = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                }, error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
            }
            else {
                Toast.error("Debe ingresar alguna referencia del nombre el vendedor")
                this.vendedores = []
            }
        },
        getDireccion(direccion) {
            return `(${direccion.cde_alias}) ${direccion.cde_direccion}, ${direccion.referencia ? direccion.referencia : '-'}, ${direccion.ubi_nombre}`
        },
        buscarProducto(value) {
            this.productos = []
            if (value) {
                ProductoVentaService.buscar({
                    producto_venta: {
                        pvt_search: value
                    }
                }).then(response => {
                    this.productos = response.data
                }, error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
            }
            else {
                Toast.error("Debe ingresar alguna referencia del producto")
                this.productos = []
            }
        },
        seleccionarCliente(cliente) {
            this.orden_venta.cli_id = cliente.cli_id
            this.clientes = []
            this.orden_venta.ovt_nombre_contacto = null
            this.orden_venta.ovt_telefono_contacto = null
            this.orden_venta.ovt_correo_contacto = null
            ClienteService.obtener({
                cliente: {
                    cli_id: cliente.cli_id
                }
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        const cliente = response.data
                        this.direcciones_envio = cliente.lista_cliente_direccion_envio
                        this.orden_venta.ovt_nombre_contacto = cliente.cli_nombre_contacto
                        this.orden_venta.ovt_telefono_contacto = cliente.cli_telefono
                        this.orden_venta.ovt_correo_contacto = cliente.cli_correo
                    }
                    else {
                        Toast.error(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        seleccionarVendedor(vendedor) {
            this.orden_venta.ven_id = vendedor.ven_id
            this.vendedores = []
        },
        agregarProducto(producto) {
            const prod = this.orden_venta.lista_orden_venta_detalle.find(i => i.pvt_id == producto.pvt_id)
            if (!prod) {
                this.orden_venta.lista_orden_venta_detalle.push({
                    sequence: this.sequence,
                    pvt_id: producto.pvt_id,
                    ovd_producto: producto.pvt_nombre,
                    pvt_precio: producto.pvt_precio,
                    pvt_precio_minimo: producto.pvt_precio_minimo,
                    ovd_precio: producto.pvt_precio_minimo,
                    ovd_cantidad: 1,
                    ovd_moneda: producto.unm_simbolo,
                    ovd_moneda_descripcion: producto.unm_descripcion,
                    ovd_subtotal: 0
                })
                this.sequence++
                this.calcular()
                this.productos = []
            }
            else {
                Toast.error("El producto ya ha sido agregado")
            }
        },
        removerProducto(sequence) {
            this.orden_venta.lista_orden_venta_detalle = this.orden_venta.lista_orden_venta_detalle.filter(item => item.sequence != sequence)
            this.calcular()
        },
        reinciar() {
            this.orden_venta.lista_orden_venta_detalle.forEach(producto => {
                producto.ovd_subtotal = producto.ovd_total = 0
                producto.ovd_igv = 0
                producto.ovd_total = 0
            })
            this.orden_venta.ovt_subtotal = 0
            this.orden_venta.ovt_igv = 0
            this.orden_venta.ovt_total = 0
        },
        calcular() {
            this.reinciar()
            // calculando los valores por item
            this.orden_venta.lista_orden_venta_detalle.forEach(producto => {
                producto.ovd_subtotal = producto.ovd_total = Numbers.round(producto.ovd_precio * producto.ovd_cantidad)
                if (this.orden_venta.ovt_igv_tasa) {
                    // calculado el igv
                    producto.ovd_igv = Numbers.round(producto.ovd_subtotal * parseFloat(this.orden_venta.ovt_igv_tasa))
                    producto.ovd_total = Numbers.round(producto.ovd_subtotal + producto.ovd_igv)
                }
            })
            // calculando los valores por orden de venta
            this.orden_venta.lista_orden_venta_detalle.forEach(item => {
                this.orden_venta.ovt_subtotal += item.ovd_subtotal
                this.orden_venta.ovt_igv += item.ovd_igv
                this.orden_venta.ovt_total += item.ovd_total
            })
            // redondeando el total al final de todos los calculos
            this.orden_venta.ovt_total = Numbers.round(this.orden_venta.ovt_total)
        },
        registrar() {
            // armando la fecha-hora entrega
            this.orden_venta.ovt_fecha_entrega = `${this.fecha_hora.day}-${this.fecha_hora.month}-${this.fecha_hora.year} ${this.fecha_hora.hour}:${this.fecha_hora.min}`
            const continuar = Validator.start(
                this.orden_venta.cli_id,
                this.orden_venta.tid_id,
                this.orden_venta.coc_id,
                this.orden_venta.ovt_nombre_contacto,
                this.orden_venta.ovt_telefono_contacto,
                this.orden_venta.ovt_correo_contacto,
                this.orden_venta.ovt_documento_identidad_contacto,
                this.orden_venta.ovt_subtotal,
                this.orden_venta.ovt_igv_tasa,
                this.orden_venta.ovt_igv,
                this.orden_venta.ovt_total,
                this.orden_venta.ovt_registrador,
                this.orden_venta.ovt_direccion_envio,
                this.orden_venta.ovt_referencia_envio,
                this.orden_venta.ubi_id,
                this.orden_venta.lista_orden_venta_detalle,
            )
            if (continuar) {
                const request = {
                    orden_venta: this.orden_venta
                }
                OrdenVentaService
                    .registrar(request)
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.close({
                                renderizar: true
                            })
                        }
                        else {
                            Toast.error(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    })
            }
            else {
                Toast.error("Falta ingresar datos para registrar la orden de venta")
            }
        },
        close({
            componente = "registrar",
            status = false,
            renderizar = false
        }) {
            this.$emit("close", {
                componente,
                status,
                renderizar,
            })
        },
        popup({ componente, abrir, buscar = false, data }) {
            switch (componente) {
                case "registrar":
                    // registrar 
                    this.activarRegistrar = abrir
                    break
            }
            if (data) {
                this.seleccionarCliente(data)
            }
        },
    },
    mounted() {
        AppService.getData(["tipos_documento_identidad", "tipos_documento", "condiciones_comerciales", "monedas", "distritos"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.tipos_documento_identidad = response.data.tipos_documento_identidad
                    this.tipos_documento = Arrays.filter(response.data.tipos_documento, "tid_descripcion", ["FACTURA"])
                    this.condiciones_comerciales = response.data.condiciones_comerciales
                    this.distritos = response.data.distritos
                    this.fecha_hora = DateTime.convertStringToObject(DateTime.todayTimeString(1))
                    this.fecha_hora.hour = "13"
                    this.fecha_hora.min = "00"
                }
                else {
                    Toast.error(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped>
.data-grid {
    min-width: 800px;
}

.cols {
    --cols: 1fr 100px 100px 100px 100px 100px;
}

.data-grid-title {
    display: grid;
    grid-template-columns: var(--cols);
    background-color: #0077b6;
    color: #fff;
    align-items: center;
}

.data-grid-body {
    display: grid;
    grid-template-columns: var(--cols);
    border: 1px solid #ccc;
    border-top: none;
    align-items: center;
}

.data-grid-body>div {
    padding: 6px 8px;
}

.data-grid-title>div {
    padding: 6px 8px;
    text-align: center;
}

.data-grid-footer {
    display: grid;
    grid-template-columns: var(--cols);
    align-items: center;
}

.data-grid-footer>div {
    padding: 6px 8px;
}

.documento {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    width: 120px;
    background-color: #f4f4f4;
    border: 1px solid #ccc;
    border-radius: 4px;
}
</style>